import { render, staticRenderFns } from "./ScrollMenuView.vue?vue&type=template&id=13ddf65a"
import script from "./ScrollMenuView.vue?vue&type=script&lang=js"
export * from "./ScrollMenuView.vue?vue&type=script&lang=js"
import style0 from "./ScrollMenuView.vue?vue&type=style&index=0&id=13ddf65a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports